import { useCallback, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ApiError } from '../../api/client';

/** 예외 객체에서 사용자에게 보여줄 메시지를 뽑아낸다. 백엔드 ErrorResponse.message 우선. */
export function toErrorMessage(error: unknown, fallback = '요청 처리 중 오류가 발생했습니다.') {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}

/**
 * API 실패 메시지를 하단 스낵바로 띄우는 공용 훅.
 * `showError(error)`를 catch에서 호출하고, 반환된 `errorToast`를 페이지 JSX에 렌더한다.
 */
export function useErrorToast() {
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  const showError = useCallback((error: unknown, fallback?: string) => {
    setMessage(toErrorMessage(error, fallback));
    setOpen(true);
  }, []);

  const close = useCallback((_?: unknown, reason?: string) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  }, []);

  const errorToast = (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={close}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={() => setOpen(false)} severity="error" variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );

  return { showError, errorToast };
}
